<template>
    <v-row align="center" v-if="change">
        <v-col cols="2" class="text-center">
            <v-avatar color="secondary" size="40">
                <v-icon color="#FFFFFF">{{ icon }}</v-icon>
            </v-avatar>
        </v-col>
        <v-col cols="10">
            <div class="title-label">
                {{ typeLabel }} <small>({{ $tc('common.blocks', 1) }} {{ change.block }})</small>
            </div>
            <div class="description-label" v-html="descriptionLabel"/>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "ChangeExerciseCard",
    props: {
        change: {
            type: Object,
            default: null
        },
    },
    computed: {
        type(vm = this) {
            return vm.change?.type
        },
        typeLabel(vm = this) {
            if (vm.type === 'exercise') return vm.$t('common.exercise_changed')
            if (vm.type === 'skip') return vm.$t('common.exercise_skipped')
            if (vm.type === 'painScale') return vm.$t('common.pain_scale')
            if (vm.type === 'setsChanged') return vm.$t('common.sets_changed')
            return ''
        },
        descriptionLabel(vm = this) {
            if (vm.type === 'exercise') return `${vm.change.oldExercise} x ${vm.change.newExercise}`
            if (vm.type === 'skip') return vm.change.exercise
            if (vm.type === 'painScale') return `${vm.change.exercise} (${vm.change.scale}/10)`
            if (vm.type === 'setsChanged') {
                const { reps, weight } = vm.change.config
                return `${vm.change.exercise}<br>${reps ? reps : ''}${reps && weight ? '<br>' : ''}${weight ? weight : ''}`
            }
            return ''
        },
        icon(vm = this) {
            if (vm.type === 'exercise') return 'mdi-swap-horizontal'
            if (vm.type === 'skip') return 'mdi-debug-step-over'
            if (vm.type === 'painScale') return '$painScale'
            if (vm.type === 'setsChanged') return 'mdi-cog'
            return ''
        }
    },
}
</script>

<style>
.title-label {
    font-weight: bold;
    font-size: 14px;
}

.description-label {
    font-size: 12px;
}
</style>